import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";

const getInvestmentStatus = async () => {
  const data = await getData(ajaxEndpoints.GET_INVESTMENT_STATUS);
  return data;
};

export default function useGetInvestmentStatus() {
  return useQuery(["getInvestmentStatus"], getInvestmentStatus);
}
